import { Component } from '@angular/core';

@Component({
  selector: 'app-database-icon',
  templateUrl: './database-icon.component.html',
  styleUrl: './database-icon.component.scss'
})
export class DatabaseIconComponent {

}
